// extracted by mini-css-extract-plugin
export var messageSideLeft = "_m1-1";
export var messageSideRight = "_m1-2";
export var subscribeToBackInStockBubbleContainer = "_m1-0";